import {Card, CardContent, Grid} from "@mui/material";
import {Children} from "react";
import {greyishBlue50, greyishBlue500} from "assets/jss/main";
import PropTypes from "prop-types";

MobileItem.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func
}

/**
 * This is the main component of the mobile item. It can take a children and it will display it in a card.
 * @returns {JSX.Element}
 */
function MobileItem({children, onClick = () => {}}) {
    const LeftPart = findSlotOfType(children, LeftSide);
    const RightPart = findSlotOfType(children, RightSide);
    return (
            <Card
                onClick={() => onClick()}
                style={{
                    height: 'fit-content',
                    boxShadow: 'none',
                    borderBottom: `1px solid ${greyishBlue50}`,
                    width: '100%',
                    backgroundColor: 'white'
                }}
            >
                <CardContent style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: '100%',
                    padding: '16px',
                    flexShrink: 0,
                }}>
                    {LeftPart}
                    {RightPart}
                </CardContent>
            </Card>
    );
}

/**
 * This is the left side of the mobile item. It can take a children a title and a subtitle.
 * It takes a title, subtitle, children
 * inverseMargin is used to add a -16px margin on the left side default is false, meaning the default margin is 0.
 * @returns {JSX.Element}
 */
function LeftSide({children, title, subtitle, underTitle}) {
    return (
        <Grid container style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: '16px',
            flexWrap: 'nowrap',
            maxWidth: '70%'
        }}>
            {children}
            <Grid style={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'nowrap',
                marginLeft: children ? '16px' : 0,
                flex: 1,
                minWidth: 0,
                overflow: 'hidden',
            }}>
                <span style={{fontSize: '14px', fontWeight: 'bold'}}>{title}</span>
                <span style={{fontSize: '12px', color: greyishBlue500, fontWeight: 400}}>{subtitle}</span>
                <div style={{marginTop: '8px'}}>
                    {underTitle}
                </div>
            </Grid>
        </Grid>
    )
}

/**
 * This is used the right side of the mobile item. It can take a children.
 * @returns {JSX.Element}
 */
function RightSide({children, maxHeight = false}) {
    return (
        <div style={{flexShrink: 0, ...(maxHeight && {alignSelf: 'stretch'})}}>
            {children}
        </div>
    )
}

function findSlotOfType(children, slotType) {
    return Children.toArray(children).find((child) => child.type === slotType);
}


export default Object.assign(MobileItem, { LeftSide, RightSide });
